import { render } from "./TransformerProforma.vue?vue&type=template&id=61880852&scoped=true&ts=true"
import script from "./TransformerProforma.vue?vue&type=script&lang=ts"
export * from "./TransformerProforma.vue?vue&type=script&lang=ts"

import "./TransformerProforma.vue?vue&type=style&index=0&id=61880852&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61880852"]])

export default __exports__